import React from 'react';
import { Drawer } from '@mui/material';
import SidebarContents from './SidebarContents';
import SuperSettingsSidebarContents from './SuperSettingsSidebarContents';

function Sidebar(props) {
    return (
        <>  
            <Drawer
                sx={{
                    width: props.drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: props.drawerWidth,
                        boxSizing: 'border-box',
                    },
                    display: { xs: 'none', md: 'block' },
                    zIndex: 5
                }}
                variant='permanent'
                anchor="left"
                open
            >
                {props.isSuperSettings ? <SuperSettingsSidebarContents collapsed={props.collapsed} onToggleCollapse={props.onToggleCollapse} /> : 
                    <SidebarContents drawerWidth={props.drawerWidth} />}
            </Drawer>
            <Drawer
                sx={{
                    width: props.drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: props.drawerWidth,
                        boxSizing: 'border-box',
                    },
                    display: { xs: 'block', md: 'none' },
                    zIndex: 5
                }}
                variant='temporary'
                anchor="left"
                ModalProps={{
                    keepMounted: true
                }}
                open={props.open}
                onClose={() => props.setOpen(false)}
            >
                {props.isSuperSettings ? <SuperSettingsSidebarContents collapsed={props.collapsed} onToggleCollapse={props.onToggleCollapse} /> : 
                    <SidebarContents drawerWidth={props.drawerWidth} />}
            </Drawer>
        </>
    );
}

export default Sidebar;